import { render, staticRenderFns } from "./144.vue?vue&type=template&id=3f35ecf0&scoped=true&"
var script = {}
import style0 from "./144.vue?vue&type=style&index=0&id=3f35ecf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f35ecf0",
  null
  
)

export default component.exports